import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { SessionInformationService } from './session-information.service';

@Injectable()
export class DataService {
    constructor(private http: HttpClient, private sessionInfo: SessionInformationService) { }

    getGivingLookups() {
        return this.http.get(`${environment.serviceName}/api/giving/lookups`).toPromise().then(result => {
            const items = result as any;
            const lookups = {};
            items.forEach(item => {
                lookups[item.name] = item.value.split('\n').map(value => value.trim());
            });

            return lookups;
        });
    }

    validateLogin(userName: string, password: string) {
        return this.http.post(`${environment.serviceName}/api/admin/login`, {userName, password}).toPromise().then(result => {
            const loginValid = result;

            return loginValid;
        });
    }


}
